import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp, faAngleDown } from '@fortawesome/pro-regular-svg-icons';
import { useLocalStorage } from '@platzi/commons';
import styles from './Dropdown.module.sass';

export const Dropdown = () => {
  const { t } = useTranslation();

  const header = useSelector((state) => state.get('school').get('hero'))?.toJS() || {};

  const [showContent, setShowContent] = useLocalStorage('schoolCollapse', 'true');

  const handleContent = () => setShowContent(showContent === 'true' ? 'false' : 'true');

  return (
    <div className={styles.Dropdown}>
      <div className="u-wrapper">
        <button onClick={handleContent}>
          <span>{t('escuela.headerDropdown.why', { school: header?.title })}</span>
          <FontAwesomeIcon icon={showContent === 'true' ? faAngleUp : faAngleDown} />
        </button>
        {showContent === 'true' && (
          <div className={styles.DropdownContent}>
            <div dangerouslySetInnerHTML={{ __html: header?.description }} />
            <div className={styles.DropdownVideo}>
              <div>
                <iframe
                  width="480"
                  height="270"
                  src={header?.video}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
